"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidType = isValidType;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isValidType(type, allowArray) {
  return typeof type === 'string' || _typeof(type) === 'symbol' || !!allowArray && Array.isArray(type) && type.every(function (t) {
    return isValidType(t, false);
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/dist/cjs/utils/isValidType.js
// module id = 558
// module chunks = 0